import {Injectable, Inject} from '@angular/core'
import {Router, NavigationStart} from '@angular/router'
import {DOCUMENT} from '@angular/common'
import {AngularFireDatabase} from 'angularfire2/database'
import {AngularFirestore} from 'angularfire2/firestore'

const BRANDCOLLECTION = 'brands'
const FOLDERCOLLECTION = 'folders'
const DEFAULTFOLDERBRANDING = {
  color_contrast: ['#6ADB7F', '#000000'],
  color_primary: ['#208EF1', '#ffffff'],
  color_shade: ['#0061BE', '#FFFFFF'],
  logo: './assets/img/logo-attaboy.png',
}

@Injectable()
export class BrandService {
  brands = []
  currentBrand: any

  constructor(
    private router: Router,
    private db: AngularFireDatabase,
    private firestore: AngularFirestore,
    @Inject(DOCUMENT) private document: HTMLDocument
  ) {
    router.events.subscribe(val => {
      if (val instanceof NavigationStart) this.resetBranding()
    })

    this.firestore
      .collection(BRANDCOLLECTION, ref => ref.orderBy('name', 'asc'))
      .valueChanges()
      .subscribe(brands => {
        this.brands = brands

        for (let i = 0; i < this.brands.length; i++) {
          if (!this.brands[i].logo) {
            if (this.brands[i].color_primary) {
              let color = {
                background: this.brands[i].color_primary[0],
                color: this.brands[i].color_primary[1],
              }
              this.brands[i].logo = BrandService.getImageWithInitialsFromName(
                this.brands[i].name,
                color
              )
            } else {
              this.brands[i].logo = BrandService.getImageWithInitialsFromName(
                this.brands[i].name
              )
            }
          }
        }
      })
  }

  syncBrands() {
    this.getBannerboyRoot().then(legacy => {
      Object.entries(legacy['folders']).forEach(([id, name]) => {
        this.syncBrand(id, legacy['folders'][id])
      })
    })
  }

  syncBrand(id, name) {
    this.firestore
      .doc([BRANDCOLLECTION, id].join('/'))
      .valueChanges()
      .subscribe(brand => {
        if (!brand) {
          this.db
            .object([FOLDERCOLLECTION, id].join('/'))
            .valueChanges()
            .subscribe(folder => {
              let brand = {
                id: id,
                name: name,
              }
              if (
                JSON.stringify(folder['branding']) !==
                JSON.stringify(DEFAULTFOLDERBRANDING)
              ) {
                brand = {...brand, ...folder['branding']}
                if (brand['logo'] == DEFAULTFOLDERBRANDING.logo)
                  delete brand['logo']
              }
              this.firestore.doc([BRANDCOLLECTION, id].join('/')).set(brand)
            })
        }
      })
  }

  getBannerboyRoot() {
    return new Promise(resolve => {
      this.db
        .object([FOLDERCOLLECTION, 'root'].join('/'))
        .valueChanges()
        .subscribe(folder => {
          const bannerboyId = Object.keys(folder['folders']).find(
            id => folder['folders'][id] === 'Bannerboy'
          )

          this.db
            .object([FOLDERCOLLECTION, bannerboyId].join('/'))
            .valueChanges()
            .subscribe(f => resolve(f))
        })
    })
  }

  getBrand(id) {
    return this.brands.filter(b => b.id == id)[0]
  }

  static getImageWithInitialsFromName(
    name,
    {background = 'fff', color = '000', size = 100, rounded = false} = {}
  ) {
    return `https://eu.ui-avatars.com/api/?background=${background.replace(
      '#',
      ''
    )}&color=${color.replace('#', '')}&size=${size}&rounded=${
      rounded ? 'true' : 'false'
    }&name=${encodeURIComponent(name)}`
  }

  setBranding(brandId) {
    let brand = {...DEFAULTFOLDERBRANDING, ...this.getBrand(brandId)}
    this.currentBrand = brand
    document.body.style.setProperty(
      '--background-color-brand-primary',
      brand.color_primary[0]
    )
    document.body.style.setProperty(
      '--color-brand-primary',
      brand.color_primary[1]
    )
    document.body.style.setProperty(
      '--background-color-brand-shade',
      brand.color_shade[0]
    )
    document.body.style.setProperty('--color-brand-shade', brand.color_shade[1])
    document.body.style.setProperty(
      '--background-color-brand-contrast',
      brand.color_contrast[0]
    )
    document.body.style.setProperty(
      '-color-brand-contrast',
      brand.color_contrast[1]
    )
    document.body.querySelector('#branded-logo').setAttribute('src', brand.logo)
  }

  get logo() {
    if (this.currentBrand && this.currentBrand.logo)
      return this.currentBrand.logo
    else return DEFAULTFOLDERBRANDING.logo
  }

  resetBranding() {
    return this.setBranding('attaboy')
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/brand/brand.service.ts